import React, { useEffect, useState } from 'react';
import '../../scss/App.scss';
import { authProvider } from '../../services/Security';
import { getBacchusURL, remainingTime } from '../shared/Functions';

const Home = ({operator, district}) => {
    const [resetToken, setResetToken] = useState<boolean>(false);
    const [count, setCount] = useState<number>(1);
    const url = getBacchusURL()

    useEffect(() => {
        loadIframe(true)
        setResetToken(false)
    }, [resetToken, district, operator])// eslint-disable-line react-hooks/exhaustive-deps

    const loadIframe = (reset) => {
        if(!reset) setCount(count + 1)
        if(reset || count === 3){
            authProvider.getNexusTokenFull().then(token => {
                setTimeout(() => setResetToken(true), remainingTime(token.tokenExpires))
                const frame = document.getElementById('active-accounts') as HTMLIFrameElement;
                frame?.contentWindow?.postMessage(JSON.stringify({
                    token: token,
                    districtId: district?.id,
                    operatorId: operator?.id,
                }), url);
    
                const frame2 = document.getElementById('email-stats') as HTMLIFrameElement;
                frame2?.contentWindow?.postMessage(JSON.stringify({
                    token: token,
                    districtId: district?.id,
                    operatorId: operator?.id,
                    type: 'Email'
                }), url);
    
                const frame3 = document.getElementById('sms-stats') as HTMLIFrameElement;
                frame3?.contentWindow?.postMessage(JSON.stringify({
                    token: token,
                    districtId: district?.id,
                    operatorId: operator?.id,
                    type: 'SMS'
                }), url);
            })
        }
    }
    return (
        <div className="App" style={{display: "flex", justifyContent: "space-around", padding:"15px"}}>
            <iframe id="active-accounts"
                title="active-accounts"
                src={`${url}/#/app/active-accounts`}
                width="500px"
                height="1100px"
                onLoad={() => loadIframe(false)}
                style={{border: "none", display:"block", marginLeft:"25px"}} />
            <iframe id="email-stats"
                title="email-stats"
                src={`${url}/#/app/iris-stats`}
                width="500px"
                height="1100px"
                onLoad={() => loadIframe(false)}
                style={{border: "none", display:"block", marginLeft:"25px"}} />
            <iframe id="sms-stats"
                title="sms-stats"
                src={`${url}/#/app/iris-stats`}
                width="500px"
                height="1100px"
                onLoad={() => loadIframe(false)}
                style={{border: "none", display:"block", marginLeft:"25px"}} />
        </div>
    );
}

export default Home;
  